module.exports = __webpack_public_path__ + "static/a-walk-in-the-woods-62f07ff42f4e16608902b6775a486f80.jpg";